import React, { useEffect, useState } from "react";
import config from "../../config";
import { authFetch } from "../../utils/Security/authFetch";

interface Role {
  roleId: number;
  roleName: string;
}

const RolesManagement: React.FC = () => {
  const [roles, setRoles] = useState<Role[]>([]);
  const [newRole, setNewRole] = useState<string>("");
  const [editRole, setEditRole] = useState<Role | null>(null);

  const API_URL = `${config.apiBaseUrl}/api/roles2`;

  // Fetch all roles
  const fetchRoles = async () => {
    try {
      const res = await authFetch(API_URL);
      if (res.ok) {
        const data = await res.json();
        setRoles(data);
      } else {
        console.error("Failed to fetch roles:", res.statusText);
      }
    } catch (err) {
      console.error("Error fetching roles:", err);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  // Add role
  const handleAdd = async () => {
    if (!newRole.trim()) return;
    try {
      const res = await authFetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ roleName: newRole }),
      });

      if (res.ok) {
        setNewRole("");
        fetchRoles();
      } else {
        console.error("Failed to add role:", res.statusText);
      }
    } catch (err) {
      console.error("Error adding role:", err);
    }
  };

  // Delete role
  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure you want to delete this role?")) return;
    try {
      const res = await authFetch(`${API_URL}/${id}`, {
        method: "DELETE",
      });

      if (res.ok) {
        fetchRoles();
      } else {
        console.error("Failed to delete role:", res.statusText);
      }
    } catch (err) {
      console.error("Error deleting role:", err);
    }
  };

  // Edit role
  const handleEdit = (role: Role) => {
    setEditRole(role);
  };

  // Update role
  const handleUpdate = async () => {
    if (!editRole) return;
    try {
      const res = await authFetch(`${API_URL}/${editRole.roleId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editRole),
      });

      if (res.ok) {
        setEditRole(null);
        fetchRoles();
      } else {
        console.error("Failed to update role:", res.statusText);
      }
    } catch (err) {
      console.error("Error updating role:", err);
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <h1 style={{ color: "#f97316" }}>Roles Management</h1>

      {/* Add Role */}
      <div style={{ marginTop: "20px", marginBottom: "20px" }}>
        <input
          type="text"
          value={newRole}
          onChange={(e) => setNewRole(e.target.value)}
          placeholder="Enter new role name"
          style={{
            padding: "8px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            marginRight: "10px",
          }}
        />
        <button
          onClick={handleAdd}
          style={{
            backgroundColor: "#f97316",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          Add Role
        </button>
      </div>

      {/* Edit Role */}
      {editRole && (
        <div style={{ marginBottom: "20px" }}>
          <input
            type="text"
            value={editRole.roleName}
            onChange={(e) =>
              setEditRole({ ...editRole, roleName: e.target.value })
            }
            style={{
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              marginRight: "10px",
            }}
          />
          <button
            onClick={handleUpdate}
            style={{
              backgroundColor: "#16a34a",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "8px",
              cursor: "pointer",
              marginRight: "5px",
            }}
          >
            Save
          </button>
          <button
            onClick={() => setEditRole(null)}
            style={{
              backgroundColor: "#dc2626",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      )}

      {/* Roles Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          backgroundColor: "white",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <thead style={{ backgroundColor: "#f97316", color: "white" }}>
          <tr>
            <th style={{ padding: "12px", textAlign: "left" }}>ID</th>
            <th style={{ padding: "12px", textAlign: "left" }}>Role Name</th>
            <th style={{ padding: "12px", textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {roles.map((role) => (
            <tr key={role.roleId} style={{ borderBottom: "1px solid #ddd" }}>
              <td style={{ padding: "12px" }}>{role.roleId}</td>
              <td style={{ padding: "12px" }}>{role.roleName}</td>
              <td style={{ padding: "12px", textAlign: "center" }}>
                <button
                  onClick={() => handleEdit(role)}
                  style={{
                    backgroundColor: "#3b82f6",
                    color: "white",
                    border: "none",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    marginRight: "8px",
                  }}
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(role.roleId)}
                  style={{
                    backgroundColor: "#dc2626",
                    color: "white",
                    border: "none",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
          {roles.length === 0 && (
            <tr>
              <td colSpan={3} style={{ padding: "20px", textAlign: "center" }}>
                No roles found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RolesManagement;
